import type { IconData } from '@stacksjs/iconify-core'

export const otherArrowsRefresh: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10.828 5.172L8 8h8V0l-2.343 2.343a8 8 0 1 0 0 11.314l-2.829-2.829a4 4 0 1 1 0-5.657\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherArrowsRefresh
